/**
 * Minimal layout for fundraiser / campaign landing pages.
 * Skips PromoBanner/PromoPopup so partner-site visitors see a focused page first.
 */

import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { GoogleAnalytics } from './GoogleAnalytics';
import { FacebookPixel } from './FacebookPixel';
import CookieConsentBanner from './CookieConsentBanner';
import { useSiteImageOverrides } from '../hooks/useSiteImageOverrides';

interface CampaignLayoutProps {
  children: ReactNode;
}

export default function CampaignLayout({ children }: CampaignLayoutProps) {
  const { getImage } = useSiteImageOverrides();
  const logo = getImage('logo', '/assets/images/branding/logo2.webp');

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-bakery-cream to-white">
      <GoogleAnalytics />
      <FacebookPixel />
      <header className="border-b border-gray-200 bg-white/90 backdrop-blur">
        <div className="container-custom flex items-center justify-between py-3">
          <Link to="/" className="flex items-center gap-2">
            <img src={logo} alt="Nanny B's Bakery" className="h-10 w-auto" />
            <span className="font-display font-semibold text-gray-900 hidden sm:inline">Nanny B&apos;s Bakery</span>
          </Link>
          <nav className="flex items-center gap-3 text-sm">
            <Link to="/menu" className="text-primary-700 hover:underline">
              Menu
            </Link>
            <Link to="/contact" className="text-gray-600 hover:text-primary-700">
              Contact
            </Link>
          </nav>
        </div>
      </header>
      <main className="flex-grow">{children}</main>
      <footer className="border-t border-gray-200 bg-white py-6 text-center text-sm text-gray-600">
        <p>
          <Link to="/" className="text-primary-700 hover:underline">
            nannybbakery.ca
          </Link>
          {' · '}
          <Link to="/privacy" className="text-primary-700 hover:underline">
            Privacy Policy
          </Link>
        </p>
      </footer>
      <CookieConsentBanner />
    </div>
  );
}
